import DOMPurify from "dompurify";

export default (data) => DOMPurify.sanitize(data);